<template>
    <div>
        <h2 class="mt-0">
            {{ $l10n.__('Préférences de documents d‘achat') }}
        </h2>

        <h3>
            {{ $l10n.__('Affichage des données') }}
        </h3>

        <p>
            {{
                $l10n.__(
                    "Les informations que vous choisissez d'afficher sur vos documents seront également affichées sur les documents de vos collaborateurs n'ayant pas accès aux préférences générales.",
                )
            }}
        </p>

        <el-checkbox-group v-model="document">
            <div class="row">
                <div class="col span_6">
                    <div class="form-group">
                        <el-checkbox label="identity">{{
                            $l10n.__('Mon identité (prénom et nom)')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="email">{{ $l10n.__('Mon adresse email') }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="phone">{{
                            $l10n.__('Mon numéro de ligne directe')
                        }}</el-checkbox>
                    </div>
                </div>
                <div class="col span_6">
                    <div class="form-group">
                        <el-checkbox label="mobile">{{
                            $l10n.__('Mon numéro de portable')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="fax">{{ $l10n.__('Mon numéro de fax') }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="address">{{ $l10n.__('Mon adresse') }}</el-checkbox>
                    </div>
                </div>
            </div>
        </el-checkbox-group>

        <p>
            {{
                $l10n.__(
                    "Vous pouvez ensuite modifier ces préférences lors de l'édition de documents",
                )
            }}
        </p>

        <h3>
            {{ $l10n.__('Affichage des colonnes') }}
        </h3>

        <p>
            {{
                $l10n.__(
                    'Les mentions que vous souhaitez afficher ou non par défaut sur vos documents pourront être réglées en fonction de vos clients (dans les préférences de chacun de vos clients) et pour chaque document.',
                )
            }}
        </p>

        <el-checkbox-group v-model="column">
            <div class="row">
                <div class="col span_6">
                    <div class="form-group">
                        <el-checkbox label="reference">{{
                            $l10n.__('Afficher la colonne Référence')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="description">{{
                            $l10n.__('Afficher la colonne Description')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="unit">{{
                            $l10n.__('Afficher la colonne prix unitaire')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="vat">{{
                            $l10n.__('Afficher la colonne TVA')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="quantity">{{
                            $l10n.__('Afficher la colonne Quantité')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="payment">{{
                            $l10n.__('Afficher les infos de Paiement')
                        }}</el-checkbox>
                    </div>
                </div>
                <div class="col span_6">
                    <div class="form-group">
                        <el-checkbox label="totals">{{
                            $l10n.__('Afficher les totaux du document')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="taxes">{{
                            $l10n.__('Afficher les taxes du document')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="taxFree">{{
                            $l10n.__('Afficher la colonne Montant')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="image">{{
                            $l10n.__('Afficher la colonne Image')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="discount">{{
                            $l10n.__('Afficher la colonne Remise')
                        }}</el-checkbox>
                    </div>
                    <div class="form-group">
                        <el-checkbox label="expireDate">{{
                            $l10n.__('Afficher la date de livraison estimée')
                        }}</el-checkbox>
                    </div>
                </div>
            </div>
        </el-checkbox-group>

        <h3>
            {{ $l10n.__('Affichage des informations produits') }}
        </h3>

        <el-checkbox-group v-model="catalog">
            <div class="form-group">
                <el-checkbox label="number">{{
                    $l10n.__('Afficher le nombre de produits du document sur le PDF')
                }}</el-checkbox>
            </div>
        </el-checkbox-group>

        <h3>
            {{ $l10n.__('Affichage des informations fournisseur') }}
        </h3>

        <el-checkbox-group v-model="third">
            <div class="form-group">
                <el-checkbox label="contact">{{
                    $l10n.__('Afficher le nom du contact fournisseur sur le PDF')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="reference">{{
                    $l10n.__('Afficher la référence du fournisseur sur le document')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="signatureOnOrder">{{
                    $l10n.__('Afficher la signature sur les bons de commandes fournisseur')
                }}</el-checkbox>
            </div>
        </el-checkbox-group>

        <h3>
            {{ $l10n.__('Informations de livraison') }}
        </h3>

        <div class="flex-level mt-3">
            <span>
                {{ $l10n.__('Temps de livraison par défaut') }}
            </span>
            <el-input-number v-model="deliveryDelay" class="dinlineb mx-2 input-small" :min="1" />
            <span>{{ $l10n.__('jour(s)') }}</span>
        </div>

        <h3>
            {{ $l10n.__('Informations de paiement') }}
        </h3>

        <el-checkbox-group v-model="payment">
            <div class="form-group">
                <el-checkbox label="delay">{{
                    $l10n.__('Afficher le délai de règlement')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="deadline">{{
                    $l10n.__('Afficher la date limite de règlement')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="means">{{
                    $l10n.__('Afficher les moyens de règlements')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="deposit">{{
                    $l10n.__('Afficher le détail de l‘acompte')
                }}</el-checkbox>
            </div>
        </el-checkbox-group>

        <div class="mt-3">
            <CompassButton :label="$t.__('common.actions.save')" @click.prevent="save" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        defaultDocument: {
            type: Array,
            required: true,
        },
        defaultCatalog: {
            type: Array,
            required: true,
        },
        defaultThird: {
            type: Array,
            required: true,
        },
        defaultPayment: {
            type: Array,
            required: true,
        },
        defaultColumn: {
            type: Array,
            required: true,
        },
        defaultDeliveryDelay: {
            type: Number,
            required: true,
        },
        docPrefsId: {
            type: Number,
            required: true,
        },
    },
    data: function () {
        return {
            document: this.defaultDocument,
            catalog: this.defaultCatalog,
            third: this.defaultThird,
            payment: this.defaultPayment,
            column: this.defaultColumn,
            deliveryDelay: this.defaultDeliveryDelay,
        };
    },
    methods: {
        save: function () {
            const options = {
                document: this.document,
                catalog: this.catalog,
                third: this.third,
                payment: this.payment,
                column: this.column,
                deliveryDelay: this.deliveryDelay,
            };

            this.$ajax.put(
                `/rest/purchase/order/preferences/${this.docPrefsId}`,
                {},
                options,
                (data) => {
                    Push.success(this.$l10n.__('Préférences enregistrées'));
                },
                (error) => {
                    const errors = {};
                    const messages = error.response.data.error.message;
                    Object.keys(messages).forEach(function (key) {
                        Push.error(messages[key]);
                    });
                },
            );
        },
    },
};
</script>
